<script lang="ts">
	import Card from '@smui/card';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import FormField from '@smui/form-field';
	import Checkbox from '@smui/checkbox';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import Area from '../../../../shared/models/Area/Area';
	import { hasRoleSysAdmin } from '../../../../shared/stores';

	export let params = {
		id: '0',
	};

	let disabled = true;

	let [data, loading, error] = Area.get(params.id);

	$: {
		if (!$data.nomeComune || !$data.nome || !$data.cognome || !$data.email) {
			disabled = true;
		} else {
			disabled = false;
		}
	}

	function onSubmit() {
		[data, loading, error] = Area.save($data);
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.areas.detail.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			<button type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16" disabled="{disabled}">
				<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
			</button>
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form" class="md:grid-cols-3 grid grid-cols-1">
			<Input required label="{$_('page.areas.detail.city_name')}" bind:value="{$data.nomeComune}" class="md:col-start-2" />
			<Input required label="{$_('page.areas.detail.mm_name')}" bind:value="{$data.nome}" class="md:col-start-2" />
			<Input required label="{$_('page.areas.detail.mm_surname')}" bind:value="{$data.cognome}" class="md:col-start-2" />
			<Input required label="{$_('page.areas.detail.mm_email')}" bind:value="{$data.email}" type="email" class="md:col-start-2" />
			<Input label="{$_('page.areas.detail.support_url')}" bind:value="{$data.urlSupporto}" type="url" class="md:col-start-2" />
			{#if $hasRoleSysAdmin}
				<FormField class="md:col-start-2">
					<Checkbox bind:checked="{$data.impersonateEnabled}" />
					<span slot="label">{$_('page.areas.detail.impersonate_enabled')}</span>
				</FormField>
			{/if}
		</form>
	{/if}
</Card>
